let isRedirecting = false;

export function handleUnauthorized() {
    if (!isRedirecting) {
        isRedirecting = true;
        localStorage.removeItem("token");
        window.location.replace("/login");
    }
}